import { Laya3DRender } from "../../RenderObjs/Laya3DRender";
export class RenderElement {
    get transform() {
        return this._renderElementOBJ.transform;
    }
    set transform(value) {
        this._transform = value;
        this._renderElementOBJ.transform = value;
    }
    get material() {
        return this._material;
    }
    set material(value) {
        if (this._material) {
            this._material._removeOwnerElement(this._renderElementOBJ);
        }
        if (value) {
            this._material = value;
            this.material._setOwner3DElement(this._renderElementOBJ);
        }
        else {
            this._material = null;
            this._renderElementOBJ.materialShaderData = null;
            this._renderElementOBJ.materialRenderQueue = 0;
            this._renderElementOBJ.subShader = this._subShader = null;
            this._renderElementOBJ.materialId = -1;
        }
    }
    get renderSubShader() {
        return this._subShader;
    }
    set renderSubShader(value) {
        this._subShader = value;
        this._renderElementOBJ.subShader = value;
    }
    get subShaderIndex() {
        return this._subShaderIndex;
    }
    set subShaderIndex(value) {
        this._subShaderIndex = value;
    }
    get render() {
        return this._baseRender;
    }
    set render(value) {
        this._baseRender = value;
        this._renderElementOBJ.renderShaderData = value._baseRenderNode.shaderData;
    }
    constructor() {
        this._subShaderIndex = 0;
        this._createRenderElementOBJ();
    }
    _createRenderElementOBJ() {
        this._renderElementOBJ = Laya3DRender.Render3DPassFactory.createRenderElement3D();
    }
    setTransform(transform) {
        this.transform = transform;
        this._renderElementOBJ.transform = transform;
    }
    setGeometry(geometry) {
        this._geometry = geometry;
        this._renderElementOBJ.geometry = geometry._geometryElementOBj;
    }
    destroy() {
        this.material = null;
        this._renderElementOBJ = null;
        this._geometry = null;
        this._baseRender = null;
        this._baseRender = null;
        this._subShader = null;
    }
}
